import { Component, OnInit } from '@angular/core';
import { ColumnConfig } from '@components/table/table.component';
import { PartnerAccount } from 'app/interfaces/partner-account.interface';
import { PartnerTableRow } from 'app/interfaces/partner-table-row.interface';
import { SelectValue } from 'app/interfaces/select-value.interface';
import { AnalyticsService } from 'app/services/analytics.service';
import { ApiService, UserInfo } from 'app/services/api.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrl: './partners.component.scss'
})
export class PartnersComponent implements OnInit {
  userInfo: UserInfo;
  selectedType: string | null = null;
  selectedTypeObject: SelectValue | null = null;
  postal: string | null = null;
  results: PartnerTableRow[] = [];
  resultsCount: number = 0;
  disclaimerOpen = false;
  hasSearched = false;
  isPostalValid = false;
  selectedPartner: PartnerAccount | null = null;

  rowActions = [
    { label: 'partners.table.contact-data', action: 'contact' }
  ];


  typeOptions: SelectValue[] = [
    { id: '1', value: 'M', label: 'partners.type.fabricator' },
    { id: '2', value: 'I', label: 'partners.type.installer' }
  ];

  tableColumns: ColumnConfig[] = [
    { key: 'type', header: 'partners.table.type', format: 'text' },
    { key: 'name', header: 'partners.table.name', format: 'text' },
    { key: 'city', header: 'partners.table.city', format: 'text' },
    { key: 'address', header: 'partners.table.address', format: 'text' },
    { key: 'contact', header: 'partners.table.contact', format: 'action' }
  ];

constructor(
    private api: ApiService,
    private analytics: AnalyticsService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.api.userInfo.subscribe((userInfo) => {
            this.userInfo = userInfo
    });
  }

  private normalizePostalCode(postal: string): string {
    const countriesWithSplit = ['GB', 'CA', 'IE', 'NL'];

    if (this.userInfo?.country && countriesWithSplit.includes(this.userInfo.country) && postal.includes(' ')) {
      return postal.split(' ')[0].trim();
    }
    return postal.trim();
  }


  validatePostalCode(): void {
    if (!this.postal || !this.selectedType || !this.userInfo?.country) {
      this.isPostalValid = false;
      return;
    }

    const normalizedPostal = this.normalizePostalCode(this.postal);

    this.api.validatePostalCode(normalizedPostal, this.userInfo.country).subscribe({
      next: (res) => {
        this.isPostalValid = res.valid;
      },
      error: () => {
        this.isPostalValid = false;
      }
    });
  }

  onPostalSelected(suggestion: { postalCode: string; city: string; country: string }) {
    this.postal = suggestion.postalCode;
    this.validatePostalCode();
  }

  onSearch() {
    if (!this.selectedType || !this.postal || !this.userInfo) return;

    const normalizedPostal = this.normalizePostalCode(this.postal);

    this.api.searchPartners(this.selectedType, normalizedPostal, this.userInfo).subscribe({
      next: (partners: PartnerAccount[]) => {
        this.results = partners.map((p) => ({
          type: this.translate.instant(this.selectedType === 'M' ? 'partners.type.fabricator' : 'partners.type.installer'),
          name: p.name,
          city: p.city,
          address: p.address,
          contact: {
            name: p.name ?? '',
            phone: p.phone ?? '',
            email: p.email ?? '',
            address: p.address ?? '',
            city: p.city ?? '',
            zipCode: p.zipCode ?? '',
            locationType: p.locationType ?? '',
            eliteStatus: p.eliteStatus ?? ''
          }
        }));
        this.resultsCount = partners.length;
        this.hasSearched = true;
        console.log('Resultados:', this.results);
        console.log('Partners:', partners);
        let partnerType = this.selectedType === 'M' ? 'fabricator' : 'installer'
        this.analytics.trackClick(`search-partner_${partnerType}`, undefined, {
          click_type: 'button',
          type: this.postal
        });
      },
      error: (err) => {
        console.error('Error en la búsqueda de socios', err);
        this.results = [];
        this.resultsCount = 0;
        this.hasSearched = true;
      }
    });
  }

  onTypeChange(value: SelectValue | null): void {
    this.selectedTypeObject = value;
    this.selectedType = value?.value ?? null;

    if (this.postal) {
      this.validatePostalCode();
    }
  }

  onOpenDisclaimer() {
    this.disclaimerOpen = true;
  }

  onDisclaimerConfirmed() {
    this.disclaimerOpen = false;
  }

  onContactClick(event: { action: string; item: PartnerTableRow }): void {
    console.log('PartnersComponent onContactClick got:', event);

    // Aquí tienes acceso al objeto completo
    const partnerContact = event.item.contact;

    // Guardamos el partner seleccionado
    this.selectedPartner = partnerContact;

    const normalizedType = partnerContact.locationType.toLowerCase().replace(/\s+/g, '-');
    this.analytics.trackClick(`contact-partner_${normalizedType}`, undefined, {
      click_type: 'button',
      type: partnerContact.name
    });
  }

    goToSalesSupport() {
        this.router.navigate(['sales-support'])
    }
}
